<template>
    <div class="row">
        <loading :active.sync=" isLoading " :is-full-page=" true "></loading>
        <div class="col-12">
            <b-card header="<i class='fa fa-file-o'></i> My Profile">
                <div class="row">
                    <div class="col-lg-8 md-12 xs-12">
                        <table class="table table-bordered table-sm">
                            <tr>
                                <th> {{ user.KD_ID === "5" ? 'NPWP' : user.KD_ID === "2" ? 'KTP' : user.KD_ID === "3" ? 'Paspor' : 'Lainnya' }} </th>
                                <td> {{ user.ID_USER }} </td>
                            </tr>
                            <tr>
                                <th>Nama</th>
                                <td> {{ user.NM_PERUSAHAAN }} </td>
                            </tr>
                            <tr>
                                <th>Alamat</th>
                                <td> {{ user.AL_PERUSAHAAN }} </td>
                            </tr>
                            <tr>
                                <th>No Telepon</th>
                                <td> {{ user.NO_TELP }} </td>
                            </tr>
                            <tr>
                                <th>Email</th>
                                <td> {{ user.EMAIL }} </td>
                            </tr>
                            <tr>
                                <th>Username</th>
                                <td> {{ user.USER_NAME }} </td>
                            </tr>
                        </table>
                    </div>
                    <div class="col-lg-4 md-12 xs-12">
                        <button v-if="user.FL_CHANGE_NPWP === 'N'" class="btn btn-warning btn-block" @click="openModalEditNPWP">Ubah NPWP <i class="fa fa-edit"></i> </button>
                    </div>
                </div>
            </b-card>
            <b-modal hide-footer title="Ubah NPWP" v-model="modalEditNPWP">
                <div class="row">
                    <div class="col-12">
                        <b-form-fieldset label="NPWP">
                            <b-form-input title="Nomor identitas perusahaan" name="NPWP" v-validate="'required|min:16'" v-model="newNpwp" type="text" placeholder="Nomor identitas perusahaan"></b-form-input>
                            <small class="text-danger" v-show="errors.has('NPWP')">
                                {{ errors.first('NPWP') }}
                            </small>
                        </b-form-fieldset>
                        <button type="submit" class="btn btn-primary pull-right" @click="updateNPWP">Simpan</button>
                    </div>
                </div>
            </b-modal>
        </div>
    </div>
</template>
<script>
import Loading from 'vue-loading-overlay'
import swal from 'sweetalert'
export default {
  components: {
    Loading
  },
  data () {
    return {
      modalEditNPWP: false,
      newNpwp: '',
      isLoading: false,
      user: {}
    }
  },
  mounted () {
    this.getDataUser()
  },
  methods: {
    openModalEditNPWP () {
      this.modalEditNPWP = true
    },
    // update NPWP by INSW
    updateNPWP () {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.isLoading = true
          this.$http.get('changeNPWP', { params: { npwp: this.newNpwp } }).then(response => {
            if (response.data.success === false) {
              this.isLoading = false
              swal('error', 'NPWP Tidak Ditemukan', 'error')
            } else if (response.data.success === true) {
              swal('success', response.data.message, 'success')
              this.getDataUser()
              this.modalEditNPWP = false
            } else {
              this.isLoading = false
              swal('error', 'Terjadi kesalahan saat memeriksa NPWP', 'error')
            }
          })
            .catch(error => {
            // Menangani kesalahan yang berasal dari server
              console.log(error)
              swal('error', 'Terjadi kesalahan saat memeriksa NPWP', 'error')
            })
            .finally(() => {
              this.isLoading = false
            })
        }
      })
    },

    // Update NPWP by Ceisa4.0
    // updateNPWP () {
    //   this.$validator.validateAll().then(result => {
    //     if (result) {
    //       this.isLoading = true
    //       this.$http.get('changeNPWP', { params: { npwp: this.newNpwp } }).then(response => {
    //         if (response.data.status === 'NOT FOUND') {
    //           this.isLoading = false
    //           swal('error', 'NPWP Tidak Ditemukan', 'error')
    //         } else if (response.data.status === 'true') {
    //           swal('success', response.data.message, 'success')
    //           this.getDataUser()
    //           this.modalEditNPWP = false
    //         } else {
    //           this.isLoading = false
    //           swal('error', 'Terjadi kesalahan saat memeriksa NPWP', 'error')
    //         }
    //       })
    //         .catch(error => {
    //         // Menangani kesalahan yang berasal dari server
    //           swal('error', error ? 'Server Bridge Error' : 'Terjadi kesalahan saat memeriksa NPWP', 'error')
    //         })
    //         .finally(() => {
    //           this.isLoading = false
    //         })
    //     }
    //   })
    // },
    getDataUser () {
      this.isLoading = true
      var data = {
        user: this.$store.getters['auth/user']['username']
      }
      this.$http.post('profile', data).then(response => {
        if (response) {
          this.user = response.data
        }
      }).finally(() => {
        this.isLoading = false
      })
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/views/account/Profile.vue?0a3ffde8